var merge = require('lodash/merge')

const mutations = {
  // Mutate professions
  SET_PROFESSIONS(state, professions) {
    state.professions = professions
  },
  SET_SEARCHABLE_PROFESSIONS(state, professions) {
    state.searchableProfessions = professions
  },
  // Mutate employment types
  SET_EMPLOYMENT_TYPES(state, employmentTypes) {
    state.employmentTypes = employmentTypes
  },
  // Mutate application state
  SET_APPLICATION_STATES(state, states) {
    state.states = states
  },
  // Mutate regions
  SET_REGIONS(state, regions) {
    state.regions = regions
  },
  // Mutate machines
  SET_MACHINES(state, machines) {
    state.machines = machines
  },
  // Mutate application state
  SET_DISTANCEORDER_STATES(state, states) {
    state.distanceOrderStates = states
  },
  SET_EXTENSIONORDER_STATES(state, states) {
    state.extensionOrderStates = states
  },
  // Mutate printorder state
  SET_PRINTORDER_STATES(state, states) {
    state.printOrderStates = states
  },

  // Mutate settings
  SET_SYSTEMSETTINGS(state, setting) {
    state.systemSettings = setting
  },
  UPDATE_SYSTEMSETTINGS(state, settings) {
    const mergedData = merge(JSON.parse(JSON.stringify(state.systemSettings)), settings)
    state.systemSettings = mergedData
  }
}
export default mutations
